import {
  GetQuoteWithFeeInput,
  GetQuoteWithFeeResponse,
  GetQuoteWithoutFeeInput,
  GetQuoteWithoutFeeResponse,
  TransactionTypeForFee,
} from 'types';

import { apiPublicClient, lambdaServerApiClient } from 'utils/apiClient';
import { COOKIES } from 'utils/consts';

export const quoteApi = {
  async getQuote(data: any) {
    const res = await lambdaServerApiClient.post('liquidity/quotes', data);
    const resBody = res.data;
    return resBody;
  },

  async getQuoteWithoutFee(data: GetQuoteWithoutFeeInput) {
    let url = `quote/get-quote-without-fee?from=${data.from}&to=${data.to}&transactionType=${data.transactionType}`;
    if (data.fromAmount !== undefined) {
      url += `&fromAmount=${data.fromAmount}`;
    }
    if (data.toAmount !== undefined) {
      url += `&toAmount=${data.toAmount}`;
    }
    try {
      const res: GetQuoteWithoutFeeResponse = await apiPublicClient({
        url,
        method: 'GET',
        headers: {
          'x-api-key': process.env.REACT_APP_QUOTE_API_KEY,
        },
      });
      const resBody = res.data!;
      return resBody;
    } catch (error) {
      throw error;
    }
  },

  async getQuoteWithFee(data: GetQuoteWithFeeInput) {
    let url = `quote/get-quote-with-fee?from=${data.from}&to=${data.to}&transactionType=${data.transactionType}&userId=${data.userId}&feeType=${data.feeType}`;
    if (data.fromAmount !== undefined) {
      url += `&fromAmount=${data.fromAmount}`;
    }
    if (data.toAmount !== undefined) {
      url += `&toAmount=${data.toAmount}`;
    }
    try {
      const token = localStorage.getItem(COOKIES.JWT);

      const res: GetQuoteWithFeeResponse = await apiPublicClient({
        url,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const resBody = res.data!;
      return resBody;
    } catch (error) {
      throw error;
    }
  },
};
